import script from "./reportsDurationAnalysis.component.vue?vue&type=script&setup=true&lang=ts"
export * from "./reportsDurationAnalysis.component.vue?vue&type=script&setup=true&lang=ts"

import "./reportsDurationAnalysis.component.vue?vue&type=style&index=0&id=4d61476c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d61476c"]])

export default __exports__